import { useEffect, useState } from "react";
import ButtonComponent from "../button";
import InputComponent from "../input";
import ReportCatalogFiltersComponent from "../report-catalog-filters";
import TabsComponent from "../tabs";
import { useDispatch, useSelector } from "react-redux";
import { providerInstitutionConstant } from "../../constants/user-constants";
import { ReportCatalogFiltersContainer, ReportCatalogFiltersHead, ReportCatalogFormats, TableWrapper, EmptyWrapper, ActionsContainer, FormError } from "../../pages/report-catalog/report-catalog.style";
import { DownloadSvg, LoaderSvg, PlaySvg, ReloadSvg, SettingsSvg } from "../../assets/svgs";
import { getAllAuthenticationExportHistoryData, getAllAuthenticationExportModuleData, getSpecificAuthenticationHistoryData } from "../../redux/slices/report-catalog-slice";
import { ReportCatalogAvailableFormats, ReportCatalogAvailableTabs, ReportCatalogFormatsConstant, ReportCatalogTabsConstant } from "../../pages/report-catalog/report-catalog.constants";
import TableComponent from "../table";
import moment from "moment";
import { AnchorButton } from "../../styles/global-styles";
import { toast } from "react-toastify";
import { exportReportToCSV, exportReportToExcel, exportReportToPDF } from "../../helpers";
import { transactionStatusConstant, transactionStatusOptions, transactionTypeOptions } from "../../constants/app-constants";
import BadgeComponent from "../badge";
import { Alert } from "@mui/material";

const AuthenticationManagementReportExport = () => {
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.loginUserReducer);
    const { institutionsWithID } = useSelector((state) => state.institutionsListReducer);
    const { schemes } = useSelector((state) => state.schemesListReducer);
    const { exportData: { authentication: { loading, data: reportExportData, history } }, specificLoading } = useSelector((state) => state.ReportCatalogReducer);

    const isProvider = (user?.institution?.id === providerInstitutionConstant?.id) && (user?.superAdmin);

    const columnMapping = {
        'acsTransId': 'ACS Transaction ID',
        'merchantName': 'Merchant Name',
        'cardholderName': 'Cardholder Name',
        'cardNumber': 'Card Number',
        'purchaseAmount': 'Purchase Amount',
        'institution': 'Institution',
        'status': 'Status',
        'transactionType': 'Transaction Type',
        'schemeName': 'Scheme Name',
        'transactionDatetime': 'Created At',
    };

    const initialStates = {
        tabs: ReportCatalogAvailableTabs,
        formats: ReportCatalogAvailableFormats,
        selectedTab: ReportCatalogAvailableTabs?.[0]?.value,
        // selectedHistory: null,
        search: {
            institution: isProvider ? undefined : (user?.institution?.label || undefined),
        },
    };

    const initialForm = {
        reportName: 'Authentication History Report',
        reportNameError: null,
        selectedFormat: ReportCatalogAvailableFormats?.[0],
    };

    const [states, setStates] = useState(initialStates);
    const [form, setForm] = useState(initialForm);

    const handleChangeForm = (e) => {
        const { name, value, type, checked } = e.target
        setForm((old) => ({
            ...old,
            [name]: ['checkbox', 'radio'].includes(type) ? checked : value
        }));
    };

    const handleChangeFilters = (e) => {
        const { name, value, type, checked } = e.target
        setStates((old) => ({
            ...old,
            search: ({
                ...old.search,
                [name]: ['checkbox', 'radio'].includes(type) ? checked : value
            })
        }));
    };

    const handleReset = () => {
        setStates(initialStates);
        setForm(initialForm);
    };

    const HandleGenerateReport = (e) => {
        e.preventDefault();

        // if (form?.reportNameError) return;

        const { transactionDatetimeFrom, transactionDatetimeTo } = states?.search || {};

        if (transactionDatetimeFrom || transactionDatetimeTo) {
            if (!transactionDatetimeFrom) {
                return toast.error("Please select From Date");
            }
            if (!transactionDatetimeTo) {
                return toast.error("Please select To Date");
            }
            if (moment(transactionDatetimeFrom).isAfter(transactionDatetimeTo)) {
                return toast.error("From Date cannot be after To Date");
            }
        }

        // if (!selectedModule || !form?.selectedFormat || !states?.search) return;

        const params = {
            format: form?.selectedFormat || ReportCatalogAvailableFormats?.[0],
            reportFilter: states?.search || {},
        };

        dispatch(getAllAuthenticationExportModuleData({ user, params }))
            .then((action) => {
                if (action?.payload && action?.payload?.length > 0) {
                    // setStates((old) => ({ ...old, selectedTab: ReportCatalogTabsConstant?.preview, search: null }));
                    setStates((old) => ({ ...old, selectedTab: ReportCatalogTabsConstant?.preview }));
                } else {
                    toast.error("No data found to export!");
                }

                if (action?.meta?.requestStatus === "fulfilled") {
                    dispatch(getAllAuthenticationExportHistoryData({ user }));
                }
            })
            .catch((error) => {
                toast.error("Failed to retrieve data");
            });
    };

    const handleExportReport = () => {
        if (reportExportData && reportExportData?.length > 0) {
            const fileData = {
                name: form?.reportName,
                list: reportExportData,
            };

            if (form?.selectedFormat === ReportCatalogFormatsConstant?.xlsx) {
                exportReportToExcel(fileData, columnMapping);
            } else if (form?.selectedFormat === ReportCatalogFormatsConstant?.csv) {
                exportReportToCSV(fileData, columnMapping);
            } else if (form?.selectedFormat === ReportCatalogFormatsConstant?.pdf) {
                exportReportToPDF(fileData, columnMapping);
            }
        } else {
            toast.info("No data available to export");
        }
    };

    const handleSpecificDownload = (row) => {
        // setStates((old) => ({ ...old, selectedHistory: { ...row } }));

        dispatch(getSpecificAuthenticationHistoryData({ user, id: row?.exportId }))
            .then((action) => {
                // setStates((old) => ({ ...old, selectedHistory: null }));

                if (action?.meta?.requestStatus === "fulfilled") {
                    if (action?.payload && action?.payload?.length > 0) {
                        const fileData = {
                            name: form?.reportName,
                            list: action?.payload,
                        };

                        if (row?.fileFormat === ReportCatalogFormatsConstant?.xlsx) {
                            exportReportToExcel(fileData, columnMapping);
                        } else if (row?.fileFormat === ReportCatalogFormatsConstant?.csv) {
                            exportReportToCSV(fileData, columnMapping);
                        } else if (row?.fileFormat === ReportCatalogFormatsConstant?.pdf) {
                            exportReportToPDF(fileData, columnMapping);
                        }
                    } else {
                        toast.error("No data found to download!");
                    }
                }
            });
    };

    useEffect(() => {
        if (user) {
            dispatch(getAllAuthenticationExportHistoryData({ user }));
        }
    }, [user, dispatch]);

    useEffect(() => {
        if (form?.reportName && form?.reportName?.trim()?.length > 129) {
            setForm((old) => ({ ...old, reportNameError: "Report name must be no more than 130 characters." }));
        } else {
            setForm((old) => ({ ...old, reportNameError: null }));
        }
    }, [form?.reportName]);

    const searchFields = [
        {
            label: 'From Date',
            type: 'date',
            placeholder: 'Select start date',
            name: 'transactionDatetimeFrom',
            value: states?.search?.transactionDatetimeFrom || '',
        },
        {
            label: 'To Date',
            type: 'date',
            placeholder: 'Select end date',
            name: 'transactionDatetimeTo',
            value: states?.search?.transactionDatetimeTo || '',
        },
        {
            label: 'Card Number',
            type: 'text',
            placeholder: 'Search by card number',
            name: 'cardNumber',
            value: states?.search?.cardNumber || '',
        },
        {
            label: 'Transaction Type',
            type: 'select',
            options: transactionTypeOptions || [],
            name: 'transactionType',
            value: states?.search?.transactionType || '',
        },
        ...(isProvider ? [{
            label: 'Institution',
            type: 'select',
            options: institutionsWithID?.map(({ label }) => ({ label, value: label })) || [],
            name: 'institution',
            value: states?.search?.institution || '',
        }] : []),
        {
            label: 'Merchant Name',
            type: 'text',
            placeholder: 'Search by merchant name',
            name: 'merchantName',
            value: states?.search?.merchantName || '',
        },
        {
            label: 'Scheme Name',
            type: 'select',
            options: schemes?.map(e => ({ label: e?.name, value: e?.name })) || [],
            name: 'schemeName',
            value: states?.search?.schemeName || '',
        },
        {
            label: 'Status',
            type: 'select',
            options: transactionStatusOptions || [],
            name: 'status',
            value: states?.search?.status || '',
        },
    ];

    const columns = [
        { field: 'acsTransId', headerName: 'ACS Transaction ID', width: 150, align: 'center' },
        { field: 'merchantName', headerName: 'Merchant Name', width: 150, align: 'center' },
        { field: 'cardholderName', headerName: 'Cardholder Name', width: 150, align: 'center' },
        { field: 'cardNumber', headerName: 'Card Number', width: 140, align: 'center' },
        { field: 'purchaseAmount', headerName: 'Purchase Amount', width: 150, align: 'center' },
        { field: 'institution', headerName: 'Institution', width: 180, align: 'center' },
        {
            field: 'status', headerName: 'Status', width: 150, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {
                            row?.status &&
                            <BadgeComponent
                                label={row?.status?.toLowerCase()}
                                type={{
                                    [transactionStatusConstant?.pass]: 'success',
                                    [transactionStatusConstant.pending]: 'warning',
                                    [transactionStatusConstant.fail]: 'error'
                                }[row?.status] || 'default'}
                            />
                        }
                    </>
                )
            },
            sortBy: (row) => row?.status,
        },
        {
            field: 'transactionType', headerName: 'Transaction Type', width: 150, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {
                            row?.transactionType &&
                            <BadgeComponent
                                label={row?.transactionType}
                            // outline
                            />
                        }
                    </>
                )
            },
            sortBy: (row) => row?.transactionType,
        },
        { field: 'schemeName', headerName: 'Scheme Name', width: 180, align: 'center' },
        {
            field: 'transactionDatetime', headerName: 'Created At', width: 180, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {/* {row?.transactionCompletionDatetime} */}
                        {row?.transactionDatetime && moment(row?.transactionDatetime).format('lll')}
                    </>
                )
            },
            sortBy: (row) => row?.transactionDatetime,
        },
    ];

    const historyColumns = [
        { field: 'exportId', headerName: 'Export ID', width: 150, align: 'center' },
        {
            field: 'fileFormat', headerName: 'File Format', width: 120, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {
                            row?.fileFormat &&
                            <BadgeComponent
                                label={row?.fileFormat?.toUpperCase()}
                                type={{
                                    [ReportCatalogFormatsConstant?.xlsx]: 'success',
                                    [ReportCatalogFormatsConstant?.pdf]: 'error',
                                }[row?.fileFormat] || 'default'}
                            />
                        }
                    </>
                )
            },
            sortBy: (row) => row?.fileFormat,
        },
        { field: 'rowCount', headerName: 'Row Count', width: 150, align: 'center' },
        {
            field: 'generatedOn', headerName: 'Generated On', width: 180, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {row?.generatedOn && moment(row?.generatedOn).format('lll')}
                    </>
                )
            },
            sortBy: (row) => row?.generatedOn,
        },
        { field: 'expires', headerName: 'Expires', width: 100, align: 'center' },
        {
            field: 'action', headerName: 'Action', width: 140, align: 'center',
            valueGetter: (row) => {
                return (
                    <>
                        {
                            row?.rowCount > 0 &&
                            <div style={{ display: 'flex', justifyContent: 'center' }}>
                                <AnchorButton onClick={() => handleSpecificDownload(row)} disabled={specificLoading !== null}>
                                    {
                                        row?.exportId === specificLoading ?
                                            <LoaderSvg />
                                            :
                                            <DownloadSvg />
                                    }
                                    <span>{row?.exportId === specificLoading ? "Downloading..." : "Download"}</span>
                                </AnchorButton>
                            </div>
                        }
                    </>
                )
            },
            sortable: false,
        },
    ];

    return (
        <TabsComponent
            // bgColor="#eaf5fe"
            onChange={(value) => setStates((old) => ({ ...old, selectedTab: value }))}
            tabs={states.tabs}
            value={states.selectedTab}
            heightfull
        >
            <>
                {
                    states.selectedTab === ReportCatalogTabsConstant?.filters &&
                    <ReportCatalogFiltersContainer>
                        <ReportCatalogFiltersHead>
                            <h4>Report Configuration</h4>
                            {
                                states?.formats && states?.formats?.length > 0 &&
                                <ReportCatalogFormats>
                                    {

                                        states?.formats?.map((format, index) => (
                                            <div
                                                key={index}
                                                className={form?.selectedFormat === format ? 'active' : ''}
                                                onClick={() => setForm((old) => ({ ...old, selectedFormat: format }))}
                                            >
                                                {format}
                                            </div>
                                        ))
                                    }
                                </ReportCatalogFormats>
                            }
                        </ReportCatalogFiltersHead>
                        <div>
                            <InputComponent
                                label='Report Name'
                                type='text'
                                placeholder='Enter report name'
                                name='reportName'
                                value={form?.reportName || ''}
                                onChange={handleChangeForm}
                                mui
                                inputProps={{ maxLength: 130 }}
                            />
                            {
                                form?.reportNameError &&
                                <FormError>{form?.reportNameError}</FormError>
                            }
                        </div>
                        <div>
                            <p style={{ margin: '0 0 5px 0' }}>Filters</p>
                            <ReportCatalogFiltersComponent
                                open={true}
                                searchFields={searchFields}
                                handleChange={handleChangeFilters}
                                cols={3}
                            />
                        </div>
                        <ActionsContainer>
                            <ButtonComponent icon={ReloadSvg} label="Reset" type="button" outline disabled={loading} onClick={handleReset} />
                            <ButtonComponent icon={PlaySvg} label={loading ? "Generating..." : "Generate"} type="button" disabled={loading} onClick={HandleGenerateReport} />
                        </ActionsContainer>
                    </ReportCatalogFiltersContainer>
                }
                {
                    states.selectedTab === ReportCatalogTabsConstant?.preview &&
                    <>
                        {
                            reportExportData && reportExportData?.length > 0 ? (
                                <TableWrapper>
                                    {
                                        reportExportData?.length > 100 &&
                                        <Alert severity="warning" sx={{ borderRadius: 0 }}>Preview mode — showing first 100 rows only.</Alert>
                                    }
                                    <TableComponent
                                        rows={reportExportData?.length > 100 ? reportExportData?.slice(0, 100) : reportExportData}
                                        columns={columns}
                                        // icon={HistorySvg}
                                        responsive={false}
                                    />
                                    <div style={{ padding: '10px' }}>
                                        <ActionsContainer>
                                            <ButtonComponent icon={SettingsSvg} label="Change filters" type="button" outline
                                                onClick={() => setStates((old) => ({ ...old, selectedTab: ReportCatalogTabsConstant?.filters }))}
                                            />
                                            <ButtonComponent icon={DownloadSvg} label={`Export ${form?.selectedFormat?.toUpperCase() || ''} now`} type="button" onClick={handleExportReport} />
                                        </ActionsContainer>
                                    </div>
                                </TableWrapper>
                            ) : (
                                <EmptyWrapper>
                                    <p>Please apply filters to search for data to export!</p>
                                    <AnchorButton onClick={() => setStates((old) => ({ ...old, selectedTab: ReportCatalogTabsConstant?.filters }))}>Apply now</AnchorButton>
                                </EmptyWrapper>
                            )
                        }
                    </>
                }
                {
                    states.selectedTab === ReportCatalogTabsConstant?.exports &&
                    <>
                        {
                            history && history?.length > 0 ? (
                                <TableWrapper>
                                    <TableComponent
                                        rows={history}
                                        columns={historyColumns}
                                        // icon={HistorySvg}
                                        responsive={false}
                                    />
                                </TableWrapper>
                            ) : (
                                <EmptyWrapper>
                                    <p>No export history found!</p>
                                    <AnchorButton onClick={() => setStates((old) => ({ ...old, selectedTab: ReportCatalogTabsConstant?.filters }))}>Export now</AnchorButton>
                                </EmptyWrapper>
                            )
                        }
                    </>
                }
            </>
        </TabsComponent>
    );
};

export default AuthenticationManagementReportExport;